import React from "react";
import {
  Box,
  Grid2,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { toCurrency } from "@helpers";
import { GainLossTypography } from "@rentablo/components";
import { TypographyWithInfoIcon } from "@rentablo/components";

interface PerformanceNumbersProps {
  primaryValue: number;
  primaryTooltip?: string;
  currency?: string;
  secondaryValue?: number | null;
  containerSx?: SxProps;
  spacing?: number;
}

export const PerformanceNumbers = ({
  primaryValue,
  primaryTooltip,
  currency,
  secondaryValue,
  containerSx,
  spacing = 11,
}: PerformanceNumbersProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isLessSm = useMediaQuery(theme.breakpoints.down("sm"));

  const renderPrimaryValue = () => {
    if (currency) {
      return toCurrency(primaryValue, currency) ?? "-";
    }
    return toCurrency(primaryValue) ?? "-";
  };

  return (
    <Grid2
      container
      spacing={spacing}
      sx={{
        ...containerSx,
      }}
    >
      <Grid2
        size={{
          xs: 6,
          sm: 6,
        }}
      >
        <Box mb={0.5}>
          <TypographyWithInfoIcon
            variant="body1"
            color="textSecondary"
            tooltipText={primaryTooltip}
          >
            {t("performanceNumbers.value")}
          </TypographyWithInfoIcon>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h4" fontWeight={isLessSm ? 500 : 600}>
            {renderPrimaryValue()}
          </Typography>
        </Box>
      </Grid2>
      {secondaryValue !== null && secondaryValue !== undefined && (
        <Grid2
          size={{
            xs: 6,
            sm: 6,
          }}
        >
          <Typography variant="body1" mb={0.5} color="textSecondary">
            {t("performanceNumbers.actual")}
          </Typography>
          <Box display="flex" alignItems="center">
            {secondaryValue !== null && secondaryValue !== undefined && (
              <GainLossTypography
                variant="h6"
                lineHeight="36px"
                value={secondaryValue}
              >
                {`${secondaryValue}%`}
              </GainLossTypography>
            )}
          </Box>
        </Grid2>
      )}
    </Grid2>
  );
};
